export default {
    CDN_PREFIX_WITHOUT_PROTOCOL: '//s3.meituan.net/v1/mss_eb9ea9cfff9840198c3ae909b17b4270/production/logan-websdk/',
    PUBLIC_KEY: '-----BEGIN PUBLIC KEY-----\n' +
        'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQChIFQ+chj+mQdyI5W2PlsD4WFm\n' +
        'zfc34I3faCpErjQv1lECdvshA+3w0trUFCV0Q+UOg5O0/oC07UgpkgWF1rvncM+x\n' +
        'EoT0pxpWFsgcBCwb5L0rKT/IjWRJS66R99kkm4bmUbtefPjkkrklqTC5ulXWKutV\n' +
        'XWXThhcdDlqE1Jpc2wIDAQAB\n' +
        '-----END PUBLIC KEY-----',
    UNIONID_LENGTH_MAX: 256,
    ENV_LENGTH_MAX: 256,
    CUSTOM_REPORT_LENGTH_MAX: 1024,
    COOKIENAME_SESSION_TOKEN: 'logan_session_token',
    COOKIENAME_LX_CUID: '_lxsdk_cuid',
    MAX_SINGLE_LOG_SIZE: 1024 * 1024,
    REPORT_PATH: '/logger/webLogUploadV2.json',
    PRE_REPORT_QUERY: '/logger/queryPreSubmit.json',
    REPORT_PREFIX_BETA: '//logan.plat.test.sankuai.com',
    REPORT_PREFIX_PROD: '//logan.sankuai.com',
    PRE_REPORT_THROTTLE_TIME: 3600 * 1000 // 前置上报节流的时间限制，该时间内同条件的重复前置上报不予处理
};
